/* eslint-disable jira/filename-case */

import { applyObservabilityHeaders } from './observability-headers.tsx';
import { applySsrFetchConfigOverrideHeaders } from './ssr-headers.tsx';

/**
 * Returns the default options for a fetch request.
 * These include headers required for distributed tracing.
 */
export function getDefaultOptions(url?: string | null): RequestInit {
	let options: RequestInit = {
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			// Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
			// oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
			Accept: ['application/json', 'text/javascript', '*/*'] as any,
			...(__SERVER__
				? {
						// Needed for call to monolith
						'x-ssr-asap-audience': 'jira',
					}
				: {}),
		},
	};

	options = url ? applyObservabilityHeaders(url, options) : options;

	if (__SERVER__) {
		options = applySsrFetchConfigOverrideHeaders(options);
	}

	return options;
}

/**
 * Will be removed with feature gate cleanup.
 * @deprecated Use {@link getDefaultOptions}
 */
export const defaultOptions: RequestInit = {
	credentials: 'same-origin',
	headers: {
		'Content-Type': 'application/json',
		// Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
		// oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
		Accept: ['application/json', 'text/javascript', '*/*'] as any,
		...(__SERVER__
			? {
					// Needed for call to monolith
					'x-ssr-asap-audience': 'jira',
				}
			: {}),
	},
};
